module.exports = __webpack_public_path__ + "img/lock-open-red.60b93d6e.svg";